import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useMakeSelector = (makeSelector, ...props) => {
    const selector = useMemo(makeSelector, []);
    return useSelector((state) => selector(state, ...props));
};
